import React, { FC } from 'react'
import { Datagrid, Filter, FilterProps, List, ListProps, SearchInput, TextField } from 'react-admin'
import { Helmet } from 'react-helmet'
import { WEB_APP_TITLE } from 'src/constants'
import RouteBreadcrumbs from '../../components/RouteBreadcrumbs'

const UnitCodeFilter: FC<Omit<FilterProps, 'children'>> = (props) => (
  <Filter {...props}>
    <SearchInput source="name,code" alwaysOn />
  </Filter>
)

const UnitCodeList: FC<ListProps> = (props) => {
  return (
    <>
      <Helmet title={`${WEB_APP_TITLE} - Unit codes`} />
      <RouteBreadcrumbs {...props} />
      <List
        {...props}
        perPage={25}
        sort={{ field: 'name', order: 'ASC' }}
        filters={<UnitCodeFilter />}
        bulkActionButtons={false}
      >
        <Datagrid rowClick="edit">
          <TextField source="name" />
          <TextField source="code" />
        </Datagrid>
      </List>
    </>
  )
}

export default UnitCodeList
